var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.792 5.415c.86.23 1.54.911 1.771 1.771C21.988 8.752 22 12 22 12s0 3.26-.424 4.814a2.519 2.519 0 0 1-1.771 1.772c-1.553.423-7.805.423-7.805.423s-6.252 0-7.805-.423a2.519 2.519 0 0 1-1.771-1.772C2 15.248 2 12 2 12s0-3.248.41-4.8c.232-.86.912-1.541 1.772-1.772 1.554-.424 7.805-.437 7.805-.437s6.252 0 7.805.424ZM15.184 12l-5.187 3.004V8.996L15.184 12Z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutube;